import { watchEffect } from 'vue';
import { useUser } from './use-user';
import { EXPERIMENT } from './experiments';
import logger from './logger';
import { useRouter } from 'vue-router';

export const useAccessGuard = (): void => {
  const { me } = useUser();

  const log = logger.getChild('access-guard');
  const router = useRouter();
  watchEffect(() => {
    if (!me.value) return;

    const hasExperiment = me.value.experiments.has(EXPERIMENT.DIALBUNNY);
    const onNoAccessPage = router.currentRoute.value.name === 'no-access';

    if (hasExperiment && !onNoAccessPage) return;

    if (!hasExperiment) {
      log.warn(
        `User does not have the ${EXPERIMENT.DIALBUNNY} experiment, redirecting to app`,
      );
      void router.replace({ name: 'no-access' });
      return;
    }

    if (onNoAccessPage) {
      log.log('User is an admin, redirecting to campaigns');
      void router.replace({ name: 'campaigns' });
    }
  });
};
